import axios from 'axios';
import {
	SET_APPLICATION_LEVEL_FULFILLED,
	SUBMIT_APPLICATION_FORM_PENDING,
	SUBMIT_APPLICATION_FORM_FULFILLED,
	SUBMIT_APPLICATION_FORM_FAILED,
	SUBMIT_APPLICATION_FORM_FILES_PENDING,
	SUBMIT_APPLICATION_FORM_FILES_FULFILLED,
	SUBMIT_APPLICATION_FORM_FILES_FAILED
} from '../constants/application.actions';
import { BASE_API_URL } from '../constants/urls';

export const setApplicationLevel = level => ({
	type: SET_APPLICATION_LEVEL_FULFILLED,
	payload: {
		level
	}
});

export const submitApplicationFormPending = () => ({
	type: SUBMIT_APPLICATION_FORM_PENDING,
	payload: null
});

export const submitApplicationFormFulfilled = applicationId => ({
	type: SUBMIT_APPLICATION_FORM_FULFILLED,
	payload: {
		applicationId
	}
});

export const submitApplicationFormFailed = serverError => ({
	type: SUBMIT_APPLICATION_FORM_FAILED,
	payload: {
		status: serverError.status,
		message: serverError.message
	}
});

export const submitApplicationFormFilesPending = () => ({
	type: SUBMIT_APPLICATION_FORM_FILES_PENDING,
	payload: null
});

export const submitApplicationFormFilesFulfilled = files => ({
	type: SUBMIT_APPLICATION_FORM_FILES_FULFILLED,
	payload: {
		files
	}
});

export const submitApplicationFormFilesFailed = () => ({
	type: SUBMIT_APPLICATION_FORM_FILES_FAILED,
	payload: null
});

export const submitApplicationFormFiles = (applicationId, files, type) => {
	return async function(dispatch) {
		dispatch(submitApplicationFormFilesPending());

		const formData = new FormData();
		Object.keys(files).map((key) => {
			const fileNameBase = files[key].name
			for(let i = 0; i < files[key].files.length; i++) {
				const fileName = fileNameBase + (i < 1 ? '' : '_' + i+1)
				const blob =  files[key].files[i]
				formData.append(blob.path, blob, fileName);
			}
		});

		const queryParam = type ? `?type=${type}` : ''
		try {
			const response = await axios.post(`${BASE_API_URL}/application/${applicationId}/files${queryParam}`, formData,
			{
				headers: {
					'Content-Type': 'multipart/form-data'
				}
			});

			dispatch(submitApplicationFormFilesFulfilled(response.data));
		} catch(error) {
			dispatch(submitApplicationFormFilesFailed(error.response.status));
		}
	};
};

export const submitApplicationForm = (data, files, type) => {
	return async function(dispatch) {
		dispatch(submitApplicationFormPending());

		const queryParam = type ? `?type=${type}` : ''
		try {
			const response = await axios.post(`${BASE_API_URL}/application${queryParam}`, data);
			dispatch(submitApplicationFormFulfilled(response.data.applicationId));
			dispatch(submitApplicationFormFiles(response.data.applicationId, files, type));
		} catch(error) {
			dispatch(submitApplicationFormFailed({ status: error.response.status, message: error.response.data.Message }));
		}
	};
};
